import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';
import styled from 'styled-components';
import AiChatbotSuccessContent from '../components/AiChatbotSuccessContent';

export default function SuccessPAge({ location }) {
  return (
    <Layout location={location} isDarkNav isChatbotNav noFooterMargin>
      <Helmet>
        <title>
          Thanks for scheduling a demo of our AI intake chatbot!
        </title>
        <meta
          name='description'
          content="We can't wait to show you what our AI intake chatbot can do for your business. Thanks for signing up!"
        />
      </Helmet>

      <MessageWrapper>
        <h1>Thanks for scheduling a demo!</h1>
        <p>
          We’re excited for you to see what our AI chatbot can do for your home services business. Here’s what comes next:
        </p>
      </MessageWrapper>
      <AiChatbotSuccessContent />
    </Layout>
  );
}

// Styled component
const MessageWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  padding: 32px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 48px;
    color: ${({ theme }) => theme.global.colors.primary};
  }

  p {
    font-size: 20px;
    margin: 0 auto;
    max-width: 800px;
    align-self: stretch;
    color: ${({ theme }) => theme.global.colors.black};
  }
`;
